"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _capitalize = _interopRequireDefault(require("lodash/capitalize"));

var _useTranslations = _interopRequireDefault(require("../../utils/useTranslations"));

var _types = require("./types");

var _schema = _interopRequireDefault(require("./schema"));

var _styles = require("./styles");

var _Flex = _interopRequireDefault(require("../Flex"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function ToggleView(props, ref) {
  var selected = props.selected,
      items = props.items,
      onChange = props.onChange,
      ariaLabel = props['aria-label'];
  var translate = (0, _useTranslations.default)();
  return _react.default.createElement(_Flex.default, {
    flexDirection: "row",
    "aria-label": translate(ariaLabel, 'toggleView.aria.label'),
    ref: ref
  }, items.map(function (_ref) {
    var id = _ref.id,
        icon = _ref.icon,
        text = _ref.text,
        rest = _objectWithoutProperties(_ref, ["id", "icon", "text"]);

    var idLabel = (0, _capitalize.default)(id);
    return _react.default.createElement(_Tooltip.default, {
      key: id,
      zIndex: 4,
      target: // eslint-disable-next-line react/jsx-wrap-multilines
      _react.default.createElement(_styles.StyledButton, _extends({
        id: id,
        icon: icon,
        "aria-label": translate(text, 'toggleView.aria.element', {
          id: idLabel
        }),
        kind: id === selected ? 'primary' : 'secondary',
        variant: id === selected ? 'normal' : 'ghost',
        onClick: function onClick() {
          return onChange && onChange(id);
        }
      }, rest))
    }, translate(text, 'toggleView.aria.element', {
      id: idLabel
    }));
  }));
}

var ToggleViewWithRef = (0, _react.forwardRef)(ToggleView); // @ts-ignore

ToggleViewWithRef.propTypes = _schema.default.propTypes; // @ts-ignore

ToggleViewWithRef.defaultProps = _types.defaultProps;
ToggleViewWithRef.displayName = 'ToggleView';
var _default = ToggleViewWithRef;
exports.default = _default;